import type {
  NotificationType,
  AdminCommunicationPayload,
  CommunicationTarget,
} from '../../../../types/admin';

export const TYPE_CONFIG: Record<
  NotificationType,
  {
    label: string;
    icon: string;
    className: string;
  }
> = {
  info: {
    label: 'Informazione',
    icon: 'bi-info-circle-fill',
    className: 'ac-type--info',
  },
  success: {
    label: 'Successo',
    icon: 'bi-check-circle-fill',
    className: 'ac-type--success',
  },
  warning: {
    label: 'Avviso',
    icon: 'bi-exclamation-triangle-fill',
    className: 'ac-type--warning',
  },
  course: {
    label: 'Corso',
    icon: 'bi-play-circle-fill',
    className: 'ac-type--course',
  },
};

export const TARGET_CONFIG: Record<
  CommunicationTarget,
  {
    label: string;
    icon: string;
    description: string;
  }
> = {
  all: {
    label: 'Tutti',
    icon: 'bi-people-fill',
    description: 'Tutti gli utenti registrati',
  },
  course: {
    label: 'Corso',
    icon: 'bi-collection-play',
    description: 'Iscritti a un corso specifico',
  },
  users: {
    label: 'Utenti specifici',
    icon: 'bi-person-lines-fill',
    description: 'Cerca e seleziona uno o più utenti',
  },
  role: {
    label: 'Per ruolo',
    icon: 'bi-shield-check',
    description: 'Tutti gli utenti con un ruolo specifico',
  },
  unconfirmed: {
    label: 'Non confermati',
    icon: 'bi-envelope-x',
    description: 'Utenti con email non ancora confermata',
  },
  no_purchase: {
    label: 'Senza acquisti',
    icon: 'bi-cart-x',
    description: 'Registrati ma senza corsi acquistati',
  },
};

export const MOCK_COURSES = [{ id: 'be-smart', title: 'Be Smart' }];

export const EMPTY_FORM: AdminCommunicationPayload = {
  title: '',
  message: '',
  type: 'info',
  target: 'all',
  targetCourseId: '',
  targetUserIds: [],
  targetRole: undefined,
  actionUrl: '',
  actionLabel: '',
};
